(function casaOrders(){
  'use strict';

  function esc(v){
    return String(v == null ? '' : v)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function money(n){
    var v = Number(n);
    return isFinite(v) ? '$' + v.toLocaleString('en-US', { maximumFractionDigits: 0 }) : '—';
  }
  function when(d){
    if (!d) return '';
    var t = new Date(d);
    return isNaN(t) ? '' : t.toLocaleDateString(undefined, { year:'numeric', month:'long', day:'numeric' });
  }

  function render(orders){
    if (!orders.length) {
      return '<p class="empty">No orders yet. When you buy a piece it will appear here, ' +
             'with its status and a record of what you paid.</p>';
    }
    // Newest first, capped: the account modal is a panel, not a report.
    var shown = orders.slice(0, 6);
    var html = shown.map(function(o){
      var st = String(o.status || '').toLowerCase();
      var label = st === 'paid' ? 'Paid' : st === 'sold' ? 'Confirmed' : (o.status || 'Received');
      var num = o.shopify_order_number ? '#' + o.shopify_order_number : (o.id ? 'Ref ' + o.id : '');
      return '<div class="casa-order">' +
               '<div class="ttl">' + esc(o.sku || 'Casa order') + '</div>' +
               '<div class="amt">' + money(o.price) + '</div>' +
               '<div class="sub">' + esc([num, when(o.created_at)].filter(Boolean).join(' · ')) + '</div>' +
               '<div class="st ' + esc(st) + '">' + esc(label) + '</div>' +
             '</div>';
    }).join('');
    if (orders.length > shown.length) {
      html += '<p class="more">Showing ' + shown.length + ' of ' + orders.length +
              ' — email info@casaconsignment.com for your full history.</p>';
    }
    return html;
  }

  function paint(){
    var modal = document.getElementById('modal-account');
    if (!modal) return;

    var host = modal.querySelector('.casa-orders');
    // Signed out: remove the panel entirely rather than leaving a stale list of
    // somebody else's orders on screen.
    if (!window.casaUser) { if (host) host.parentNode.removeChild(host); return; }

    if (!host) {
      var anchor = modal.querySelector('#account-sub') ||
                   modal.querySelector('.modal-head') ||
                   modal.querySelector('.modal');
      if (!anchor || !anchor.parentNode) return;
      host = document.createElement('div');
      host.className = 'casa-orders';
      host.innerHTML = '<h4>Your orders</h4><p class="empty">Loading…</p>';
      anchor.parentNode.insertBefore(host, anchor.nextSibling);
    }

    fetch('/api/orders', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        // The customer may have signed out while this was in flight.
        if (!window.casaUser) { if (host && host.parentNode) host.parentNode.removeChild(host); return; }
        var orders = (j && j.orders) || [];
        host.innerHTML = '<h4>Your orders</h4>' + render(orders);
      })
      .catch(function(){
        if (host) host.innerHTML = '<h4>Your orders</h4><p class="empty">' +
          'We could not load your orders just now. Email info@casaconsignment.com and we will look them up.</p>';
      });
  }

  // updateAccountUI() is declared inside the storefront's auth IIFE, so it is NOT
  // on window and cannot be wrapped — a hook on it would have silently done
  // nothing. window.casaUser IS global, so watch the modal instead: repaint
  // whenever it opens, and whenever the signed-in identity differs from what the
  // panel was last drawn for. That covers sign-in, sign-out and registration
  // without depending on internals we do not own.
  var drawnFor = null;
  function sync(){
    var modal = document.getElementById('modal-account');
    if (!modal) return;
    var open = modal.classList.contains('open');
    var who = (window.casaUser && window.casaUser.email) || null;
    if (!open) { drawnFor = null; return; }
    if (who === drawnFor && modal.querySelector('.casa-orders')) return;
    drawnFor = who;
    paint();
  }
  try {
    var modalEl = document.getElementById('modal-account');
    if (modalEl) new MutationObserver(sync).observe(modalEl, { attributes: true, attributeFilter: ['class'] });
  } catch(e){}
  // casaUser is populated by an async /auth/me on load, which can land after the
  // modal is already open, so poll briefly while it is visible.
  setInterval(function(){
    var m = document.getElementById('modal-account');
    if (m && m.classList.contains('open')) sync();
  }, 700);

  function hook(){
    if (typeof window.openModal === 'function' && !window.openModal.__casaOrders) {
      var origOpen = window.openModal;
      window.openModal = function(name){
        var r = origOpen.apply(this, arguments);
        if (name === 'account') setTimeout(paint, 40);
        return r;
      };
      window.openModal.__casaOrders = true;
    }
  }
  hook();
  setTimeout(hook, 900); setTimeout(hook, 2400);

  window.casaRefreshOrders = paint;

  console.log('  ✓ Your orders: on-domain order history in the account panel, from /api/orders');
})();
